import { fullServiceHistoryMessages, FullServiceHistoryOptions } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"

export const useFullServiceHistoryOptions = (): RadioOption[] => {
	const { formatMessage } = useIntl()
	return [
		{
			label: formatMessage(fullServiceHistoryMessages.INCOMPLETE),
			value: FullServiceHistoryOptions.INCOMPLETE,
		},
		{
			label: formatMessage(fullServiceHistoryMessages.COMPLETE),
			value: FullServiceHistoryOptions.COMPLETE,
		},
	]
}
